module.exports = __webpack_public_path__ + "static/media/hypno-timer.acb22425.png";